import { getClass, listClinicalGroups } from '$lib/api/classes';
import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';

export const load: LayoutLoad = ({ params, fetch }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);

  const classPromise = getClass(id, fetch);
  const clinicalGroupsPromise = listClinicalGroups(id, fetch);
  return {
    classPromise,
    clinicalGroupsPromise,
    meta: {
      title: 'Class',
      activeNav: 'classes',
      breadcrumbs: {
        activeTitle: classPromise.then(c => c.name),
        items: [
          {
            title: 'Classes',
            href: '/admin/classes',
          },
        ],
      },
    },
  };
};
